/**
 * The shimmer is a 200%-wide gradient the sweep animation slides across, so the
 * background size has to stay double the box for the highlight to travel.
 * Alpha on `foreground` rather than a flat surface token keeps it a tint over
 * whatever the message sits on, which is what the original translucent black was.
 */
export const SHIMMER_CLASSES =
  'relative mb-1.5 overflow-hidden rounded-lg bg-linear-to-r from-foreground/2 via-foreground/5 to-foreground/2 bg-[length:200%_100%] px-3 py-2';

export const SHIMMER_BORDER_CLASSES = 'border border-foreground/10';

/**
 * Fades the clipped tail of the collapsed reasoning text into the page instead of
 * cutting it off. It paints the page background and masks itself out downwards,
 * so it only reads as a fade while it sits on that background.
 */
export const FADE_OVERLAY_CLASSES =
  'pointer-events-none absolute inset-x-0 top-0 z-1 h-full bg-background [mask-image:linear-gradient(to_bottom,rgba(0,0,0,0.8)_0%,rgba(0,0,0,0.5)_20%,rgba(0,0,0,0.2)_40%,transparent_100%)]';
